export const STORAGE_KEY = 'avengers-hub-user';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

export const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL || 'http://localhost:8000';

export const EXCEL_MERGER_BASE_URL = process.env.REACT_APP_EXCEL_MERGER_BASE_URL || 'http://localhost:8000';

export const RENTAL_CONVERTER_BASE_URL =
  process.env.REACT_APP_RENTAL_CONVERTER_BASE_URL || 'http://localhost:8000';

export const AMAZON_SALES_BASE_URL =
  process.env.REACT_APP_AMAZON_SALES_BASE_URL || 'http://localhost:8000';

export const PAYROLL_JOURNAL_BASE_URL =
  process.env.REACT_APP_PAYROLL_JOURNAL_BASE_URL || 'http://localhost:8000';

export const CASH_TRACKER_BASE_URL =
  process.env.REACT_APP_CASH_TRACKER_BASE_URL || 'http://localhost:8000';

export const HR_CONSOLIDATOR_BASE_URL =
  process.env.REACT_APP_HR_CONSOLIDATOR_BASE_URL || 'http://localhost:8000';

export const ATTENDANCE_BASE_URL =
  process.env.REACT_APP_ATTENDANCE_BASE_URL || 'http://localhost:8000';

export const APP_NAME = 'Avengers Assembly Hub';
export const APP_TAGLINE = 'Whatever it takes to get the job done.';

export const CATALOG_BASE_URL =
  process.env.REACT_APP_CATALOG_BASE_URL || 'http://localhost:8000';
